module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket"
  }, [_c('span', {
    staticClass: "ticket__header"
  }, [_vm._v(_vm._s(_vm.ticketDetail.accountName))]), _vm._v(" "), _c('div', {
    staticClass: "ticket__content"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "ticket__content-tips"
  }, [_vm._v("\n      领券消费更优惠哦\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "ticket-content"
  }, [_c('span', {
    staticClass: "ticket__amount"
  }, [_c('span', {
    staticClass: "ticket__icon"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ticketDetail.couponAmount))])]), _vm._v(" "), _c('span', {
    staticClass: "ticket__rule"
  }, [(_vm.ticketDetail.ruleType) ? _c('span', {
    staticClass: "rule__content"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "rule__content"
  }, [_vm._v("满" + _vm._s(_vm.ticketDetail.consumeAmount) + "元减" + _vm._s(_vm.ticketDetail.couponAmount) + "元")]), _vm._v(" "), (_vm.ticketDetail.expireType) ? _c('span', {
    staticClass: "rule__time"
  }, [_vm._v("激活后" + _vm._s(_vm.ticketDetail.activeExpireDays) + "天")]) : _c('span', {
    staticClass: "rule__time"
  }, [_vm._v(_vm._s(_vm.ticketDetail.expireTime) + "到期")])])]), _vm._v(" "), _c('span', {
    staticClass: "qrcode"
  })]), _vm._v(" "), (!_vm.bind) ? _c('div', {
    staticClass: "input__box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.phone),
      expression: "formItem.phone"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "tel",
      "maxlength": "11",
      "placeholder": "请输入您的手机号码"
    },
    domProps: {
      "value": (_vm.formItem.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.phone = $event.target.value
      }, function($event) {
        _vm.validPhone = false
      }],
      "blur": _vm.resetScroll
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.name),
      expression: "formItem.name"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.formItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.name = $event.target.value
      }, function($event) {
        _vm.validName = false
      }],
      "blur": _vm.resetScroll
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.bind) ? _c('a', {
    staticClass: "getNow",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.getItNow
    }
  }, [_vm._v("确认并领取优惠券")]) : _c('a', {
    staticClass: "getNow",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("已经领取")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ticket__content-header"
  }, [_vm._v("\n      恭喜您！收到一张"), _c('span', {
    staticStyle: {
      "color": "#FF6A3C"
    }
  }, [_vm._v("优惠券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20abd2c1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/index.vue
// module id = 354
// module chunks = 0